module.exports = __webpack_public_path__ + "img/img0.b5670d94.jpg";